// extracted by mini-css-extract-plugin
module.exports = {"container":"_3QmgYaNYSeVOjYKrfIq2Co","value":"c6yS06EKDR0AKin25cDF2","percentageMark":"_2W0T3UIzV27TZS5xB-dCqr"};